import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  fonts: {
    heading: "'Trebuchet MS', '29LTAzer', sans-serif",
    body: "'Trebuchet MS', '29LTAzer', sans-serif",
  },
  styles: {
    global: {
      body: {
        bg: "white",
        color: "gray.800",
        fontFamily: "body",
      },
      "*": {
        fontFamily: "inherit",
      },
      "[lang='ar']": {
        fontFamily: "'29LTAzer', sans-serif",
        direction: "rtl",
      },
      "[lang='en']": {
        fontFamily: "'Trebuchet MS', sans-serif",
        direction: "ltr",
      },
    },
  },
});

export default theme;
